module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1984"
    }
  }, [_c('b', [_vm._v("CONTENTS ")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "4",
      "src": "images/4.jpg"
    }
  })]), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d8e3361"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Haye_ISBN9781605501390_epub_c4_r1#d7e2816",
      "id": "d14e136"
    }
  }, [_vm._v("PART I "), _c('br'), _c('i', [_vm._v("Words You Absolutely Should Know")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d8e251051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Haye_ISBN9781605501390_epub_c6_r1#d7e26187150",
      "id": "d14e142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II "), _c('br'), _c('i', [_vm._v("Words Most People Don’t Know")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d8e384381"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Haye_ISBN9781605501390_epub_c7_r1#d7e40044228",
      "id": "d14e148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III "), _c('br'), _c('i', [_vm._v("Words You Should Know but Probably Don’t")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d8e515821"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Haye_ISBN9781605501390_epub_c8_r1#d7e53720306",
      "id": "d14e154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV "), _c('br'), _c('i', [_vm._v("Foreign Idioms You Should Know")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d8e531881"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Haye_ISBN9781605501390_epub_c9_r1#d7e55374318",
      "id": "d14e160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V "), _c('br'), _c('i', [_vm._v("People and Place Words You Should Know")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d8e548711"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Haye_ISBN9781605501390_epub_c10_r1#d7e57075330",
      "id": "d14e166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VI "), _c('br'), _c('i', [_vm._v("Words You Should Know to Sound Overeducated")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d8e681791"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Haye_ISBN9781605501390_epub_c11_r1#d7e71026408",
      "id": "d14e172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VII "), _c('br'), _c('i', [_vm._v("Words You Probably Shouldn’t Know")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e2c067c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Haye_ISBN9781605501390_epub_c3_r1.vue
// module id = 66
// module chunks = 0